@file:OptIn(ExperimentalBlockRichTextApi::class)

package com.taocent.simple.compose.component.blockrichtext.internal.block.renderer

import androidx.compose.ui.focus.FocusRequester
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.input.TextFieldValue
import com.taocent.simple.compose.component.blockrichtext.ExperimentalBlockRichTextApi
import com.taocent.simple.compose.component.richtext.core.RichTextState

/**
 * 把目标单元格的光标先放到指定位置,再 requestFocus。
 *
 * **顺序很重要**:`restoreTextFieldValue` 必须在 `requestFocus` **之前**调用,
 * 因为 [RichTextState] 在 onValueChange 路径下会以 BasicTextField 当前 selection 为准,
 * 一旦 cell 已经聚焦,新设的 selection 可能被 focus 后到来的 IME state 同步覆盖。
 *
 * - [caretAtEnd] = true:光标落在 cell 末尾(用于 ↑/← 进入)
 * - [caretAtEnd] = false:光标落在 cell 开头(用于 ↓/→ 进入)
 *
 * 与 [com.taocent.simple.compose.component.blockrichtext.BlockState] 内的
 * [com.taocent.simple.compose.component.blockrichtext.focusTableCell] 协同:
 * cell 内 [TableCellEditor] 的 onFocus 回调会负责把 [BlockState.editorCursor] /
 * [BlockState.focusedTableCellState] / [BlockState.focusedTableCellFocusRequester]
 * 一并更新,这里只需触发 FocusRequester。
 */
internal fun focusCellAtCaret(
    cellStates: MutableMap<String, RichTextState>,
    cellFocusRequesters: MutableMap<Pair<String, String>, FocusRequester>,
    blockId: String,
    rowId: String,
    cellId: String,
    caretAtEnd: Boolean
) {
    val key = "${blockId}_${rowId}_${cellId}"
    val state = cellStates[key]
    if (state != null) {
        val tfv = state.textFieldValue
        val targetSelection = if (caretAtEnd) {
            TextRange(tfv.text.length)
        } else {
            TextRange(0)
        }
        if (tfv.selection != targetSelection) {
            state.restoreTextFieldValue(
                TextFieldValue(
                    annotatedString = tfv.annotatedString,
                    selection = targetSelection
                )
            )
        }
    }
    cellFocusRequesters[Pair(rowId, cellId)]?.requestFocus()
}
